<template>
  <div class="main-content">
    <search-item
      :key="identify"
      :ref="identify"
      :show-more-scheme="true"
      :col-settings="{span:12}"
      :show-simple="showSimple"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      @advSearchItemCallBack="fetchData"
      @simSearchItemCallBack="fetchDataByKeyWord"
      @advToggle="scrollCallback"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper" style="min-height: 300px">
      <cargo-ag-grid
        :config-module="gridConfigModule"
        :grid-params.sync="chargeGrid.gridParams"
        :grid-options="chargeGrid.gridOptions"
        :column-defs="columnDefs"
        :row-data="chargeGrid.rowData"
      />
    </div>
    <div id="footer-wrapper" class="pagination-wrapper">
      <div style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <charge-currency-total-group
          v-if="reCalc"
          :amount-to-currency="localCurrency"
          data-field="chargeAmount"
          currency-field="chargeCurrency"
          rate-field="chargeRate"
          ar-field="chargeReceivable"
          :arap-group="false"
          arap-order="ap"
          type="auto"
          :data-provider="totalAmountToCurrencyChargeGrid.dataProvider"
        />
        <charge-count-group
          v-if="reCalc && showChargeCount"
          :new-by-job="newByJob"
          :selected-count="totalAmountToCurrencyChargeGrid.selectedCount"
          :data-provider="totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider"
          :display-and-count-field-list="totalAmountToCurrencyChargeGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="alwaysShow"
        />
      </div>
      <cargo-pagination
        :config-module="gridConfigModule"
        :total="searchConditions.totalChargeGrid"
        :page.sync="searchConditions.pageNumChargeGrid"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { getGridSelected } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { Once } from '@/utils/commonUtil'
import { queryChargeList } from '@/api/clearing/billingNative'
import lodash from 'lodash'
import { formatNumberToThousands } from '@/utils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import CustomLableUtils from '@/utils/CustomLabelUtils'

export default {
  name: 'NativeQueryChargeForPayApply',
  components: { searchItem, ChargeCountGroup, chargeCurrencyTotalGroup },
  props: {
    showSimple: { type: Boolean, default: true }, // 是否显示简单查询
    identify: { type: String, required: true, default: 'nativeQueryCharge' }, // ID
    viewSource: { type: String, required: true, default: '' }, // 引用页面
    configModule: { type: String, required: true, default: '' }, // 高级查询条件
    gridConfigModule: { type: String, required: true, default: '' }, // 列表设置
    jobStateParam: { type: String, default: '' },
    chargeStateParam: { type: String, default: '' },
    confirmStateParam: { type: String, default: '' },
    confirmState: { type: Number, default: -1 }, // 确认状态
    hasDiffCharge: { type: Number, default: -1 }, // 是否关联差异对冲费用
    hasBilling: { type: Number, default: -1 }, // 是否关联账单
    hasBillPayment: { type: Number, default: -1 }, // 是否关联付款申请
    paidOff: { type: Number, default: 0 }, // 是否销账
    commission: { type: Number, default: 0 }, // 是否佣金
    advance: { type: Number, default: -1 }, // 是否垫付
    shared: { type: Number, default: 0 }, // 是否分摊费用
    adjustment: { type: Number, default: -1 }, // 是否调整
    checkVerifiedAmount: { type: Boolean, default: false }, // 是否过滤全部核销数据
    isShowWriteOff: { type: Boolean, default: true }, // 是否显示已核销的费用
    showInvoiceNo: { type: Boolean, default: false }, // 显示发票号
    showTotalUnverifiedAmount: { type: Boolean, default: false }, // 显示未销金额总计
    showBillingNo: { type: Boolean, default: false }, // 显示账单号
    hasInvoice: { type: Number, default: -1 }, // 是否开票
    isAr: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外 0:国内 1:国外
    isNeedInvoice: { type: Number, default: -1 }, // 是否开票
    inputDateStart: { type: String, default: '' }, // 默认业务日期查询
    inputDateEnd: { type: String, default: '' },
    showVerifiedAmount: { type: Boolean, default: true }, // 是否显示已核销金额
    showUnverifiedAmount: { type: Boolean, default: true }, // 是否显示未核销金额
    showInvoiceState: { type: Boolean, default: true }, // 显示开票状态
    showRealClearingState: { type: Boolean, default: true }, // 显示真实的核销状态
    showSelectionCount: { type: Boolean, default: true }, // 是否显示选中记录数
    showGroupingTotal: { type: Boolean, default: true }, // 是否显示合计
    showChargeCount: { type: Boolean, default: false }, // 是否显示合计:新组件
    selectedEntitiesForHedging: { type: Array, default: () => [] }, // 排除
    exceptKeys: { type: Array, default: () => [] }, // 在查询中想要例外的Keys
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    totalCurrencyField: { type: String, default: 'currency' }, // 币种字段
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    rateField: { type: String, default: 'rate' }, // 汇率字段
    type: { type: String, default: 'revenueAbs', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // // 合计类型
    showTotalGroup: { type: Boolean, default: true }, // 是否显示合计
    arApGroup: { type: Boolean, default: false }, // 是否分实收实付
    defaultOptions: { type: Array, default: () => [] }, // 默认的选项
    defaultOptionValues: { type: Array, default: () => [] }, // 选项的默认值列表
    showControlledCharge: { type: Boolean, default: true }, // 是否显示受控费用
    isControlled: { type: Boolean, default: false }, // 是否有应付受控费用权限
    isCostControlled: { type: Boolean, default: false }, // 是否有应收受控费用权限
    newByJob: { type: Number, default: 0 }, // 用于财务审核 和 付款申请 1 //1 付款申请 业务; 2 付款申请 费用; 3 财务审核
    hidePop: { type: Boolean, default: false }, // 根据弹框展示/隐藏
    alwaysShow: { type: Boolean, default: true },
    internalCharge: { type: Boolean, default: false } // 内结
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      searchItemCode: '按费用查询',
      simQueryPlaceholder: this.$t('Clearing.QuickSearchBusinessNumber'),
      chargeGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onRowSelected: this.onRowSelected,
          onRowClicked: this.onRowClicked
        },
        rowData: []
      },
      searchConditions: {
        totalChargeGrid: 0, // 按费用
        pageNumChargeGrid: 1, // 按费用
        pageSize: 20,
        snapshotConditionsCharge: [], // 高级查询条件（点击查询时的快照状态）
        requiresCharge: [],
        invoiceReceiveChargeState: '', // InvoiceReceiveChargeState, 开票-应收费用-费用状态查询(发票)
        invoicePayChargeState: '', // InvoicePayChargeState, 开票-应付费用-费用状态查询(发票)
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [] // 确认状态
      },
      initSearchConditions: {
        totalChargeGrid: 0, // 按费用
        pageNumChargeGrid: 1, // 按费用
        pageSize: 20,
        snapshotConditionsCharge: [], // 高级查询条件（点击查询时的快照状态）
        requiresCharge: [],
        invoiceReceiveChargeState: '', // InvoiceReceiveChargeState, 开票-应收费用-费用状态查询(发票)
        invoicePayChargeState: '', // InvoicePayChargeState, 开票-应付费用-费用状态查询(发票)
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [] // 确认状态
      },
      totalAmountToCurrencyChargeGrid: { // 右下角合计组件相关参数
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [],
        chargeCountGroupDataProvider: [] // 弹出框数据源
      },
      once: new Once(this),
      selectedItem: {}, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      chargeAuditFlow: false // 2555专用
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true, lockVisible: true
        },
        {
          headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobJobNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {}
            }
          }
        },
        { headerName: this.$t('Payment.warehouseNo'), field: 'jobWarehouseNo', width: 200 },
        { headerName: this.$t('Payment.bookingNo'), field: 'jobBookingNo', width: 200 },
        { headerName: this.$t('Payment.itemNo'), field: 'jobPoNo', width: 200 },
        { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', width: 200 },
        { headerName: this.$t('Payment.containerNo'), field: 'jobContainerNo', width: 200 },
        {
          headerName: this.$t('Payment.eta'), field: 'jobEta', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.etd'), field: 'jobEtd', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        { headerName: this.$t('Payment.atd'), field: 'jobAtd', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.ata'), field: 'jobAta', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.billNo'), field: 'billingBillingNo', width: 200 },
        {
          headerName: this.$t('Payment.settleAccountsTo'), field: 'chargeAccountId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 200 },
        { headerName: this.$t('Payment.separateNumber'), field: 'jobImportHbl', width: 200 },
        {
          headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.businessType'), field: 'jobLob', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVesselFlight', width: 200 },
        {
          headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', width: 200,
          cellRenderer: (params) => {
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else {
              return ''
            }
          },
          filter: false,
          filterParams: {}
        },
        {
          headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', width: 200,
          cellRenderer: (params) => {
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else {
              return ''
            }
          },
          filter: false,
          filterParams: {}
        },
        {
          headerName: this.$t('Payment.sales'), field: 'jobSales', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.operation'), field: 'jobOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.customerService'), field: 'jobCsr', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Payment.businessReferenceNumber'), field: 'jobCustomerRefNo', width: 200 },
        {
          headerName: this.$t('Payment.customJobType'), field: 'jobCustomJobType', width: 200,
          valueGetter: (params) => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.jobCustomJobType, 'name', params.data.jobLob, params.data.fba)
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Payment.financialDate'), field: 'chargeAccountingDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.domesticInternational'), field: 'chargeOversea', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.overseaLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.isReceivable'), field: 'chargeReceivable', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('Payment.feeStatus'), field: 'chargeChargeState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('Payment.auditor'), field: 'chargeAuditor', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.confirmationStatus'), field: 'chargeConfirmState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeConfirmStateLabFun(params.value)
          },
          hide: this.showCommonChargeState
        },
        {
          headerName: this.$t('Payment.chargeItem'), field: 'chargeChargeItemId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        { headerName: this.$t('Payment.unit'), field: 'chargeMeasure', width: 200 },
        { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 200 },
        { headerName: this.$t('Payment.quantity'), field: 'chargeQuantity', width: 200 },
        {
          headerName: this.$t('Payment.unitPrice'), field: 'chargeUnitRate', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'cargo-cell-input',
            attrs: {
              isEditCBFunc: false,
              complexTextConverter: (data, val) => {
                return !val ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2), 2)
              }
            }
          }
        },
        {
          headerName: this.$t('Payment.taxIncludedPrice'), field: 'chargeAmount', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'cargo-cell-input',
            attrs: {
              isEditCBFunc: false,
              complexTextConverter: (data, val) => {
                return !val ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2), 2)
              }
            }
          }
        },
        {
          headerName: this.$t('Payment.taxExcludedPrice'), field: 'chargeExcludingTaxAmount', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'cargo-cell-input',
            attrs: {
              isEditCBFunc: false,
              complexTextConverter: (data, val) => {
                return !val ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2), 2)
              }
            }
          }
        },
        {
          headerName: this.$t('Payment.taxAmount'), field: 'chargeTaxAmount', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'cargo-cell-input',
            attrs: {
              isEditCBFunc: false,
              complexTextConverter: (data, val) => {
                return !val ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2), 2)
              }
            }
          }
        },
        {
          headerName: this.$t('Payment.taxRate'), field: 'chargeTaxRate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('Payment.theAmountOfWriteOffs'), field: 'chargeVerifiedAmount', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'cargo-cell-input',
            attrs: {
              isEditCBFunc: false,
              complexTextConverter: (data, val) => {
                return !val ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2), 2)
              }
            }
          },
          hide: this.showVerifiedAmount
        },
        {
          headerName: this.$t('Payment.amountNotWrittenOff'), field: 'chargeUnverifiedAmount', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'cargo-cell-input',
            attrs: {
              isEditCBFunc: false,
              complexTextConverter: (data, val) => {
                return !val ? '0.00' : formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2), 2)
              }
            }
          },
          hide: this.showUnverifiedAmount
        },
        { headerName: this.$t('Payment.contactPerson'), field: 'chargeContactPerson', width: 200, hide: true },
        {
          headerName: this.$t('Payment.creator'), field: 'chargeCreatedBy', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.dateOfCreation'), field: 'chargeDateCreated', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        { headerName: this.$t('Payment.remarks'), field: 'chargeRemarks', width: 200, hide: true },
        { headerName: this.$t('Payment.relatedJob'), field: 'jobRelatedJob', width: 200, hide: true },
        { headerName: this.$t('Payment.trustFromJob'), field: 'jobTrustFromJob', width: 200, hide: true },
        {
          headerName: this.$t('Payment.carrierId'), field: 'jobCarrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.confirmDate'), field: 'chargeConfirmDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.confirmUser'), field: 'chargeConfirmUser', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.planner'), field: 'jobPlanner', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.invoiceDateAll'), field: 'invoiceInvoiceDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.invoiceNo'), field: 'chargeInvoiceNo', width: 200, hide: this.showInvoiceNo },
        { headerName: this.$t('Payment.invoiceHeader'), field: 'invoiceTitle', width: 200 },
        {
          headerName: this.$t('Payment.isNeedInvoice'), field: 'chargeNeedInvoice', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Payment.confirmRemarks'), field: 'chargeConfirmRemarks', width: 200 },
        {
          headerName: this.$t('Payment.writeOffDate'), field: 'chargeClearingDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', width: 200, hide: true },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', width: 200, hide: true },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', width: 200, hide: true },
        {
          headerName: this.$t('CargoMsg.Cargo_ExpenseBoxNo'),
          field: 'chargeRelationContainerNo',
          initialWidth: 200,
          hide: true
        }, {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'jobProjectName',
          colId: 'jobProjectName',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'jobBookingAgent',
          colId: 'jobBookingAgent',
          hide: true,
          cellRenderer: (params) => {
            if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
              return ''
            }
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
          },
          initialWidth: 200
        },
        {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'exChangeAgent',
          colId: 'exChangeAgent',
          hide: true,
          cellRenderer: (params) => {
            if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
              return params.data.jobBookingAgent ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobBookingAgent, 'auto_1') : ''
            }
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
          },
          initialWidth: 200
        },
        {
          headerName: this.$t('SeaExport.CategoryOfGoods'),
          field: 'cargoCode',
          colId: 'cargoCode',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
          },
          hide: true,
          width: 150
        }
      ]
    }
  },
  watch: {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
    this.initCustomSearchItems()
    this.setLocalCurrency()
  },
  beforeMount() {
  },
  mounted() {
    this.scrollCallback()
    document.querySelector('.queryCharge').addEventListener('scroll', this.scrollCallback)
  },
  methods: {
    // 配置参数
    async initConfig() {
      // 业务状态
      this.searchConditions.jobStates = await LoadDefaultQueryParam.getConfigQueryParam(this.jobStateParam, SystemConstants.JOB_STATES)
      // 费用确认状态
      this.searchConditions.confirmStates = await LoadDefaultQueryParam.getConfigQueryParam(this.confirmStateParam, ChargeConstants.CONFIRM_STATES)
      // 费用状态
      this.searchConditions.chargeStates = await LoadDefaultQueryParam.getConfigQueryParam(this.chargeStateParam, ChargeConstants.CHARGE_STATES)
      this.chargeAuditFlow = Number(cache.config.get('chargeAuditFlow')) === 1
      if (!this.chargeAuditFlow) {
        for (let i = 0; i < this.searchConditions.chargeStates.length; i++) {
          const chargeState = this.searchConditions.chargeStates[i]
          if (chargeState.code === ChargeConstants.STATE_REJECT.code) {
            this.searchConditions.chargeStates.splice(i, 1)
            break
          }
        }
      }
    },
    // 查询
    async fetchData(conditions, simpleTriggerMode = false) {
      await this.initConfig()
      this.searchConditions.pageNumChargeGrid = 1
      const finallyConditions = []
      const advConditions = []
      // 结算类型中的"月结"是按照大于1来判断的，不能用等于
      for (let i = 0; i < conditions.length; i++) {
        const condition = conditions[i]
        if (condition.fieldName === 'charge.BILL_PAYMENT_UUID') {
          this.hasBillPayment = condition.value ? 1 : 0
          continue
        }
        if (condition.fieldName === 'creditInfo.CREDIT_DATE_LIMITED' && condition.value === 1) {
          condition.operator = OperatorConstants.OPERATOR_GREATER.code
          continue
        }
        advConditions.push(condition)
      }
      // 应收/应付
      if (this.isAr !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', this.isAr === 1, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否佣金
      if (this.commission !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.COMMISSION', this.commission === 1, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否垫付
      if (this.advance !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ADVANCE', this.advance === 1, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否分摊费用
      if (this.shared !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.SHARED', this.shared === 1, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 国内/国外
      if (this.oversea > -1) {
        const condition = new AdvancedSearchOption(null, 'charge.OVERSEA', this.oversea === 1, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否开票
      if (this.hasInvoice !== -1) {
        const operator = this.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', null, operator)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 红冲状态
      const condition = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code)
      finallyConditions.push(condition.formatObj2Json())
      // 是否关联差异对冲费用
      if (this.hasDiffCharge !== -1) {
        const operator = this.hasDiffCharge === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        finallyConditions.push(new AdvancedSearchOption(null, 'charge.DIFF_CHARGE_UUID', null, operator))
      }
      // 业务状态
      if (this.searchConditions.jobStates && this.searchConditions.jobStates.length > 0 && !LoadDefaultQueryParam.isSelectOption('job.JOB_STATE', conditions)) {
        const jobStates = LoadDefaultQueryParam.convertCommonStateToInt(this.searchConditions.jobStates)
        const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 费用状态
      if (this.searchConditions.chargeStates && this.searchConditions.chargeStates.length > 0 && !LoadDefaultQueryParam.isSelectOption('charge.CHARGE_STATE', conditions)) {
        const chargeStates = LoadDefaultQueryParam.convertCommonStateToInt(this.searchConditions.chargeStates)
        const condition = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', chargeStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 费用确认状态
      if (this.searchConditions.confirmStates && this.searchConditions.confirmStates.length > 0 && !LoadDefaultQueryParam.isSelectOption('charge.CONFIRM_STATE', conditions)) {
        const confirmStates = LoadDefaultQueryParam.convertCommonStateToInt(this.searchConditions.confirmStates)
        const condition = new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', confirmStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否做过付款申请
      if (this.hasBillPayment !== -1) {
        const operator = this.hasBillPayment === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.BILL_PAYMENT_UUID', null, operator)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否做过账单
      if (this.hasBilling !== -1) {
        const operator = this.hasBilling === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.BILLING_UUID', null, operator)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否做过账单
      if (!this.isShowWriteOff) {
        const condition = new AdvancedSearchOption(null, 'charge.PAID_OFF', false, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 对冲开票/销账
      if (this.exceptKeys.length > 0) {
        const option = new AdvancedSearchOption(null, 'charge.UUID', this.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 内结
      if (this.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否显示受控费用
      if (!this.showControlledCharge) {
        this.getControlledConditions(finallyConditions)
      }
      finallyConditions.push(...advConditions)
      // 条件保存
      this.searchConditions.snapshotConditionsCharge = finallyConditions
      this.searchConditions.roleMap = {
        checkVerifiedAmount: true
      }
      this.toQueryChargeList()
    },
    // 获取charge控制条件
    getControlledConditions(conditions) {
    // 是否有应付受控费用权限
      const isControlled = this.$checkPermission(['button_Charge_controlled'])
      // 是否有应收受控费用权限
      const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
      let value = 0
      if (!isControlled && !isCostControlled) {
        value = 1
      } else if (!isControlled) {
        value = 2
      } else if (!isCostControlled) {
        value = 3
      }
      if (value !== 0) {
        conditions.push(new AdvancedSearchOption(null, 'cIsControlled', value).formatObj2Json())
      }
    },
    // 快捷检索
    fetchDataByKeyWord(keyWord) {
      if (!StrUtils.isEmpty(keyWord)) {
        this.searchConditions.pageNumChargeGrid = 1
        const conditions = []
        const option = new AdvancedSearchOption(null, 'job.JOB_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        if (conditions.length > 0) {
          this.fetchData(conditions, true)
        }
      }
    },
    // 分页触发查询
    fetchDataByPage(param) {
      this.toQueryChargeList()
    },
    toQueryChargeList() {
      const { snapshotConditionsCharge: conditions, requiresCharge: requires, pageNumChargeGrid: pageNum, pageSize, roleMap } = this.searchConditions
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, 'requestSource': this.viewSource, 'roleMap': roleMap }
      this.loading = getLoading()
      queryChargeList(requestBody).then(res => {
        this.chargeGrid.rowData = lodash.cloneDeep(res.data.list)
        this.searchConditions.totalChargeGrid = Number(res.data.total)
        //
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.chargeGrid.rowData
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(this.chargeGrid.rowData)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      }).finally(() => {
        this.loading.close()
      })
    },
    //
    initCustomSearchItems() {
      const defaultSearchFields = []
      if (this.searchConditions.jobStates && this.searchConditions.jobStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.billingCharge_businessStatus'
        searchField.itemName = 'job.JOB_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = this.searchConditions.jobStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.searchConditions.chargeStates && this.searchConditions.chargeStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.billingCharge_feeStatus'
        searchField.itemName = 'charge.CHARGE_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = this.searchConditions.chargeStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.searchConditions.confirmStates && this.searchConditions.confirmStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.billingCharge_confirmStatus'
        searchField.itemName = 'charge.CONFIRM_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = this.searchConditions.confirmStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (defaultSearchFields && defaultSearchFields.length > 0) {
        this.customSearchItems = defaultSearchFields
      }
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid(event) {
      console.log('toRefreshSelectedCountChargeGrid', event)
      this.filterChange()
      // this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
    },
    filterChange() {
      this.selections = getGridSelected(this.chargeGrid.gridOptions)
      if (this.selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, this.selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.chargeGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.chargeGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.chargeGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = selections
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(selections)
        this.totalAmountToCurrencyChargeGrid.selectedCount = selections.length
      } else if (arg == 1) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = selections
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(selections)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.chargeGrid.rowData
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(this.chargeGrid.rowData)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      }
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
    // 需要根据value装配this.templateSelectorDialog中相关内容(done)
      if (value) {
        // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_DETAIL", {"JOB_UUID":job.key}, FlexGlobals.topLevelApplication as DisplayObject);
        this.templateSelectorDialog.cxt = this.billingGrid.rowData.find(item => item.uuid === value)
        this.templateSelectorDialog.data.JOB_UUID = value
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(`没有找到对应的打印模板`)
      }
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.queryCharge')
        const footer = document.getElementById('footer-wrapper')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    // 获取勾选的项目
    getSelections() {
      return getGridSelected(this.chargeGrid.gridOptions)
    },
    // 重置相关属性
    reSetProperties() {
      this.chargeGrid.rowData = []
      // 处理pageSize被本地化保存后不需要重置
      const pageSize = this.searchConditions.pageSize
      this.initSearchConditions.pageSize = pageSize

      this.searchConditions = this.initSearchConditions
      this.totalAmountToCurrencyChargeGrid.dataProvider = []
      this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = []
      this.totalAmountToCurrencyChargeGrid.selectedCount = 0
    },
    // 重新组装合计弹出框数据源
    getChargeCountGroupDataProvider(rowData = []) {
      const list = []
      if (rowData && rowData.length > 0) {
        for (const charge of rowData) {
          const map = {
            charge_currency: charge.chargeCurrency,
            charge_receivable: charge.chargeReceivable,
            charge_exchangeRate: charge.chargeExchangeRate,
            charge_amount: charge.chargeReceivable ? charge.chargeAmount * -1 : charge.chargeAmount
          }
          list.push(map)
        }
      }
      return list
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
<style lang="scss">
.queryCharge{
  #footer-wrapper {
    .fixedBottom {
      position: relative;
      bottom: 0;
      right: 15px;
      background: #fff;
    }
  }
}

</style>
